// @ts-ignore: Ignore import error because Ember Tooltip is not typed
import { template as template_fd9b2463e5f141cfb5666b64daa1f11a } from "@ember/template-compiler";
import EmberTooltip from 'ember-tooltips/components/ember-tooltip';
import BvText from 'volta/components/bv-text';
import orElse from 'volta/helpers/or-else';
import or from 'ember-truth-helpers/helpers/or';
import classNames from 'volta/helpers/class-names';
import { hash } from '@ember/helper';
import type { ContentValue } from '@glint/template';
import type { TOC } from '@ember/component/template-only';
import type { TText } from 'volta/utils/text-utils';
export type TTooltipSide = 'auto' | 'left' | 'right' | 'bottom' | 'top';
export interface TooltipContent {
    text?: ContentValue;
    subtext?: ContentValue;
}
export interface BvTooltipSignature {
    Args: {
        class?: string;
        content?: (TooltipContent | undefined)[];
        event?: 'hover' | 'click' | 'none';
        isShown?: boolean;
        popperContainer?: string;
        popperOptions?: string;
        side?: TTooltipSide;
        subtext?: ContentValue;
        targetId?: string;
        text?: TText;
    };
    Blocks: {
        default: [];
    };
    Element: HTMLElement;
}
const BvTooltipComponent: TOC<BvTooltipSignature> = template_fd9b2463e5f141cfb5666b64daa1f11a(`
  <EmberTooltip
    @targetId={{@targetId}}
    @isShown={{@isShown}}
    @event={{orElse @event 'hover'}}
    @side={{or @side 'bottom'}}
    @effect='none'
    @delay={{200}}
    @spacing={{8}}
    @popperContainer={{orElse @popperContainer 'body'}}
    @arrowClass='bv-tooltip__arrow'
    @innerClass='bv-tooltip__inner'
    @tooltipClass={{classNames 'bv-tooltip' @class}}
    @popperOptions={{orElse
      @popperOptions
      (hash modifiers=(hash preventOverflow=(hash escapeWithReference=false)))
    }}
  >
    {{#if (has-block)}}
      {{yield}}
    {{else}}
      {{@text}}
    {{/if}}
    {{#if @subtext}}
      <BvText class='u-d-flex u-color-gray-3'>
        {{@subtext}}
      </BvText>
    {{/if}}
    {{#each @content as |item|}}
      {{#if item}}
        {{#if item.text}}
          {{item.text}}
        {{/if}}
        {{#if item.subtext}}
          <BvText class='u-d-flex u-color-gray-3'>
            {{item.subtext}}
          </BvText>
        {{/if}}
      {{/if}}
    {{/each}}
  </EmberTooltip>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
export default BvTooltipComponent;
declare module '@glint/environment-ember-loose/registry' {
    export default interface Registry {
        BvTooltip: typeof BvTooltipComponent;
        'bv-tooltip': typeof BvTooltipComponent;
    }
}
